import { render, staticRenderFns } from "./AbkSubEvents.vue?vue&type=template&id=2c18fc25&scoped=true&"
import script from "./AbkSubEvents.vue?vue&type=script&lang=js&"
export * from "./AbkSubEvents.vue?vue&type=script&lang=js&"
import style0 from "./AbkSubEvents.vue?vue&type=style&index=0&id=2c18fc25&scoped=true&lang=scss&"
import style1 from "./AbkSubEvents.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18fc25",
  null
  
)

export default component.exports